import { useCallback, useState } from "react";

import { FichaService } from "../../services/ficha.service";
import { useHistory } from "react-router-dom";
import { ViewFichaEntidade } from "../../components/viewFichaEntidade";
import { InputCpf } from "../../components/input/InputCpf";
import { Wrapper } from "../../components/viewFichaEntidade/styles";
import { Row, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import ReactLoading from 'react-loading';


export function ConsultaPorCPF() {
  const [cpf, setCpf] = useState("");
  const history = useHistory();
  const [dados, setDados] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const load = useCallback(async () => {
    try{
      if (cpf) {
        setLoading(true);
        const patt1 = /[0-9]/g;
        const newCPF = cpf.match(patt1).join("");
        const { data } = await FichaService.getAllByCPF({ cpf: newCPF });
        setDados(data);
      }
    }catch(err){

    }finally{
      setLoading(false);
    }

  }, [cpf]);

  return (
    <Wrapper>
      <br />
      <br />
      <Row>
        <ArrowLeftOutlined
          className="btnBack"
          onClick={() => history.goBack()}
          style={{ fontSize: "16px", marginRight: 10, marginTop: 10 }}
        />
        <h1>Consulta por CPF</h1>
      </Row>
      <InputCpf
        placeholder="Busca por CPF"
        allowClear
        enterButton="Buscar"
        size="large"
        value={cpf}
        onChange={(nome) => setCpf(nome)}
      />
      <br /> <br />
      <Button onClick={load}>Pesquisar</Button>
      <br />
      {dados &&
        dados.map((entidade) => (
          <>
            <ViewFichaEntidade key={entidade.id} entidade={entidade} />
          </>
        ))}

      {isLoading && (<ReactLoading type="spin" color="black" delay={200} />)}
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </Wrapper>
  );
}
